import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfidenceBadgeComponent } from './confidence-badge.component';
import { ConfidenceColorPipeModule } from '../../features/detection/pipes/confidence-color-pipe/confidence-color-pipe.module';
import { ConfidenceLabelPipeModule } from '../../features/detection/pipes/confidence-label-pipe/confidence-label-pipe.module';

@NgModule({
  imports: [CommonModule, ConfidenceColorPipeModule, ConfidenceLabelPipeModule],
  declarations: [ConfidenceBadgeComponent],
  exports: [ConfidenceBadgeComponent],
})
export class ConfidenceBadgeModule {}
